import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { DefaultTS } from '../SharedComponents/Default';
import { Router } from '@angular/router';
import { _throw as throwError } from 'rxjs/observable/throw';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private Defaultts: DefaultTS, private router: Router) {
 
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.Defaultts.LoginUserKey;
    if (token) {
      request = request.clone({
        setHeaders: {
          'token': token,
        },
      });
    }
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          //this.authService.logout();
        }
        if (err.status === 400) {
          this.router.navigate(['/login'])
        }
        if (err.status === 500) {
          let url = this.router.url;
          this.router.navigate([url]);

          this.Defaultts.ShowAlert(JSON.stringify(err.error))
        }
        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Interceptors/token-interceptor.service.ts